import { ENDPOINTS } from 'shared/constants/ENDPOINTS';
import { useAxios } from 'shared/hooks/useAxios';
import {
  IProgramRequestPayload,
  IProgramResponsePayload,
  ITvProgramListCreatePayload,
  ITvProgramListUpdatePayload,
} from 'shared/interfaces/IProgram';
import { transformPayload } from 'shared/utils/transformPayload';

export const useProgramDao = () => {
  const { GET, DELETE, POST, PUT } = useAxios();

  const getProgram = async (payload?: IProgramRequestPayload) => {
    const transformedPayload = transformPayload<IProgramRequestPayload>(payload);

    const response = await GET<IProgramResponsePayload>({
      url: ENDPOINTS.PROGRAM,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  // FOR FILTER SEARCH

  const getProgramSearch = async (payload?: IProgramRequestPayload) => {
    const transformedPayload = transformPayload<IProgramRequestPayload>(payload);

    const response = await GET<IProgramResponsePayload>({
      url: ENDPOINTS.PROGRAM,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  // Get single

  const getSingleTvProgramList = async (id?: string) => {
    const transformedPayload = transformPayload({ _id: id, limit: 1 });

    const response = await GET<IProgramResponsePayload>({
      url: `${ENDPOINTS.PROGRAM}/show`,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  const createTvProgramList = async (payload?: { data?: ITvProgramListCreatePayload }) => {
    const transformedPayload = transformPayload<ITvProgramListCreatePayload>(payload?.data);

    const formData = new FormData();
    formData.append('token', transformedPayload);

    const response = await POST({
      url: `${ENDPOINTS.PROGRAM}/create`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  };

  const updateTvProgramList = async (payload?: { data?: ITvProgramListUpdatePayload }) => {
    const transformedPayload = transformPayload<ITvProgramListUpdatePayload>(payload?.data);

    const formData = new FormData();
    formData.append('token', transformedPayload);

    const response = await PUT({
      url: `${ENDPOINTS.PROGRAM}/update`,
      data: formData,
      params: {
        token: formData.get('token'),
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  };

  //
  const deleteTvProgramList = async (id: string) => {
    const transformedPayload = transformPayload({ _id: id });

    const response = await DELETE({
      url: `${ENDPOINTS.PROGRAM}/delete`,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  return {
    getProgram,
    getSingleTvProgramList,
    createTvProgramList,
    updateTvProgramList,
    deleteTvProgramList,
    //
    getProgramSearch,
  };
};
